/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    InternalApiTransliterationRequest,
    InternalApiTransliterationRequestFromJSON,
    InternalApiTransliterationRequestToJSON,
    InternalApiTransliterationResponse,
    InternalApiTransliterationResponseFromJSON,
    InternalApiTransliterationResponseToJSON,
} from '../models';

export interface TransliterateRequest {
    internalApiTransliterationRequest: InternalApiTransliterationRequest;
}

/**
 * 
 */
export class TransliterationApi extends runtime.BaseAPI {

    /**
     * Transliterate text with specified feature flags
     */
    async transliterateRaw(requestParameters: TransliterateRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<InternalApiTransliterationResponse>> {
        if (requestParameters.internalApiTransliterationRequest === null || requestParameters.internalApiTransliterationRequest === undefined) {
            throw new runtime.RequiredError('internalApiTransliterationRequest','Required parameter requestParameters.internalApiTransliterationRequest was null or undefined when calling transliterate.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("OAuth2", ["aml"]);
        }

        const response = await this.request({
            path: `/v1/transliterate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: InternalApiTransliterationRequestToJSON(requestParameters.internalApiTransliterationRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => InternalApiTransliterationResponseFromJSON(jsonValue));
    }

    /**
     * Transliterate text with specified feature flags
     */
    async transliterate(requestParameters: TransliterateRequest, initOverrides?: RequestInit): Promise<InternalApiTransliterationResponse> {
        const response = await this.transliterateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
